import Report from "./Report";

export default { Report };


// WEBPACK FOOTER //
// ./src/services/API/components/Pushapi/index.js